<template>
	<BaseCmsPage v-slot="{page}" :fetch-slug-segments="2" @load="onPageLoad">
		<ClientOnly>
			<div class="auth-box">
				<div class="wrapper">
					<div class="a-col a-col1">
						<div class="signup-iframe-container">
							<iframe class="signup-iframe" :src="iframeUrl" frameborder="0" width="800" height="670"></iframe>
						</div>
					</div>

					<div class="a-col a-col2">
						<div v-html="page?.content"></div>
						<BaseCmsLabel code="already_register" tag="h2" class="auth-title auth-title-special" />
						<BaseAuthUser v-slot="{urls}">
							<div class="submit-container">
								<NuxtLink :to="urls?.auth_login" class="btn btn-green btn-medium submit-btn"><BaseCmsLabel code="login" tag="span" /></NuxtLink>
								<p class="auth-links">
									<NuxtLink :to="urls?.auth_forgotten_password" class="button2 forgotten"><BaseCmsLabel code="forgotten_password" tag="span" /></NuxtLink>
								</p>
							</div>
						</BaseAuthUser>
					</div>
				</div>
			</div>
			<template #fallback>
				<BaseThemeUiLoading />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	import {config} from '../hapi.config';
	const { getAppUrl } = useApiRoutes();

	onMounted(() => {
		window.addEventListener('message', function(event) {
			if(event.data === 'onboarding-success') {
				return navigateTo('/uspesno-zakljucen-postopek/');
			}
			if(event.data === 'onboarding-login') {
				return navigateTo(getAppUrl('auth_login'));
			}
		}, false);
	})

	const iframeUrl = computed(() => {
		const iframeBasePath = (['prod', 'beta'].includes(config.default)) ? 'apigw' : 'devapigw';
		return `https://${iframeBasePath}.bigbang.si:7443/people-onboarding-ui/new-account-email?channel=SI`;
	});

	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	.auth-box{
		background: #F0F2F4; padding: 50px 0;
		&>.wrapper{display: flex;}
		:deep(h2){font: 25px/1.2 @font; letter-spacing: -0.35px; padding: 0 0 10px;}
		:deep(ul){
			list-style: none; padding: 0; margin: 0 0 15px;
			li{
				position: relative; padding: 2px 0 4px 25px;
				&:before{.pseudo(12px, 1px); background: @blue; top: 14px; left: 0; z-index: 1;}
			}
		}

		@media (max-width: @t){
			padding: 30px 0 60px;
			:deep(ul){
				margin-left: 0;
				&>li:before{top: 12px;}
			}
		}
		@media (max-width: @m){
			padding: 20px 0 40px;
			:deep(h2){font-size: 22px;}
			:deep(ul){ margin-left: 0;}
		}
		@media (max-width: @ms){
			background: @white; padding: 0; border-bottom: 1px solid @borderColor;
			&>.wrapper{display: block; margin: 0;}
			:deep(h2){font-size: 18px; line-height: 23px; padding: 0 0 7px;}
			:deep(ul){
				margin: 0 0 10px; font-size: 12px;
				li{
					position: relative; padding: 2px 0 2px 20px;
					&:before{width: 10px; top: 11px; left: 0;}
				}
			}
		}
	}

	.a-col{
		padding: 60px 140px;

		@media (max-width: @l){padding: 40px 60px 50px;}
		@media (max-width: @t){padding: 25px 30px;}
		@media (max-width: @m){padding: 20px;}
		@media (max-width: @ms){width: 100%; padding: 15px 15px 25px;}
	}
	.signup-iframe-container{
		overflow: hidden; width: 740px;
		@media (max-width: @l){width: 660px;}
		@media (max-width: @t){width: auto;}
		@media (max-width: @m){width: 100%;}
		iframe{
			margin-top: -110px;
			@media (max-width: @l){margin-left: -82px;}
			@media (max-width: @t){width: 100%; height: 540px; margin: auto;}
			@media (max-width: @ms){width: 100%; height: 525px; margin: 0;}
		}
	}
	.a-col1{
		padding: 0; width: 700px;
		@media (max-width: @l){width: 60%;}
		@media (max-width: @t){width: 50%; flex-grow: 0; flex-shrink: 0;}


		@media (max-width: @ms){width: 100%; border-bottom: 1px solid @borderColor;}
	}
	.a-col2{
		padding-right: 70px;

		@media (max-width: @l){padding: 40px 0 40px 20px;}
		@media (max-width: @t){padding: 55px 0 25px 40px; font-size: 14px;}
		@media (max-width: @ms){padding: 25px 15px 40px; font-size: 12px;}
	}
	.auth-title{
		font: 25px/1.2 @font; letter-spacing: -0.35px; padding: 0 0 10px;

		@media (max-width: @m){font-size: 22px;}
		@media (max-width: @ms){font-size: 18px; line-height: 23px; padding: 0 0 7px;}
	}
	.auth-title-special{
		padding-top: 40px!important;

		@media (max-width: @t){padding-top: 20px!important;}
		@media (max-width: @m){padding-top: 15px!important;}
		@media (max-width: @ms){padding-top: 10px!important;}
	}
</style>
